module.exports = __webpack_public_path__ + "static/media/h.f9a42a3b.svg";